import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import th from 'vee-validate/dist/locale/th';

// loop over all rules

for (let rule in rules) {
    extend(rule, {
        ...rules[rule], // add the rule
        message: th.messages[rule] // add its message
    });
}
extend('exacly8', {
    validate: value => {
        if (value.length !== 8) {

            return false
        } else {

            return true;
        }
    },
    message: 'เลขที่กรมธรรม์ต้องเป็นตัวอักษรหรือตัวเลข จำนวน 8 หลักเท่านั้น'
});
extend('idcard', {
    validate: value => {
        var val = value
        if (val.toString().length !== 13 || val.toString().includes('.')) {
            return false
        } else {
            return true;
        }
    },
    message: 'เลขบัตรประจำตัวประชาชนต้องเป็นตัวเลขจำนวน 13 หลักเท่านั้น'
});